import { render } from "./FAQ.vue?vue&type=template&id=225b61f8&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=225b61f8&lang=scss&scoped=true"
import "./FAQ.vue?vue&type=style&index=1&id=225b61f8&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225b61f8"]])

export default __exports__